import { textWrap } from './_lib/text-wrap.js';
import { shuffle } from './_lib/shuffle.js';

export const textAnime = {
  duration: 25,
  observeOptions: {
    //ルートとしてviewportを設定
    root: null,
    //上下0px、左右0px手前で発火
    rootMargin: '0px 0px',
    // 交差領域が50%の時
    threshold: 1
  },
  split: ()=>{
    const targets = document.querySelectorAll('.textAnime');
    Array.prototype.slice.call(targets,0).forEach((elm,i)=>{
      //文字分割
      let text = textWrap(elm.innerText);
      //分割した文字列をHTMLに投入
      elm.innerHTML = text;
      //再分割しないようにターゲットクラスを削除
      elm.classList.remove('textAnime');
      //シャッフルアニメーション用クラス
      elm.classList.add('textShuffle');
    });
  },
  reset: ()=>{
    const targets = document.querySelectorAll('span.show');
    Array.prototype.slice.call(targets,0).forEach((elm) => {
      elm.classList.remove('show');
    });
    const logo = shuffle(document.querySelectorAll('.logoShuffle'));
    Array.prototype.slice.call(logo,0).forEach((elm) => {
      elm.classList.remove('show');
    });
  },
  //可視範囲でシャッフルアニメーション
  observe: ()=>{
    const targets = document.querySelectorAll('.textShuffle');
    const observer = new IntersectionObserver(callback, textAnime.observeOptions);
    function callback(entries, observer){
      entries.forEach((entry) => {
        if(entry.isIntersecting){
          const span = shuffle(entry.target.querySelectorAll('span'));
          Array.prototype.slice.call(span,0).forEach((elm, i) => {
            setTimeout(()=>{
              elm.classList.add('show');
            }, i * textAnime.duration);
          });
          observer.unobserve(entry.target);
        }
      });
    }
    targets.forEach((target) => {
      observer.observe(target);
    });
  },
  logo: ()=>{
    const logo = shuffle(document.querySelectorAll('.logoShuffle'));
    Array.prototype.slice.call(logo,0).forEach((elm, i) => {
      setTimeout(()=>{
        elm.classList.add('show');
      }, i * textAnime.duration);
    });
  },
  init: ()=>{
    textAnime.split();
    textAnime.observe();
    textAnime.logo();
  }
}
